import requestSuccessFailureHelper from '../utils/helpers/ReduxHelper';

import {
  SINGLE_SESSION,
  UPCOMING_EVENTS,
  USER_BOOKED_EVENTS,
  GET_VENUE_AREAS,
  COURTS
} from '../utils/constants';

const { reducer: singleSession } = requestSuccessFailureHelper(
  SINGLE_SESSION,
  () => {}
);
const { reducer: upcomingEvents } = requestSuccessFailureHelper(
  UPCOMING_EVENTS,
  () => {}
);
const { reducer: userBookedEvents } = requestSuccessFailureHelper(
  USER_BOOKED_EVENTS,
  () => {}
);
const { reducer: venueAreas } = requestSuccessFailureHelper(
  GET_VENUE_AREAS,
  () => {}
);
const { reducer: courts } = requestSuccessFailureHelper(COURTS, () => {});

export default {
  singleSession,
  upcomingEvents,
  userBookedEvents,
  venueAreas,
  courts
};



// WEBPACK FOOTER //
// ./src/reducers/requestSuccessFailureReducers.js